export const Reactive_Key = 'reactive:properties';
export const ReactiveSubscriptions_Key = 'reactive:subscribers';
